/**
 * commerce events should start with `tracking:commerce:`
 *
 * non-commerce events should start with `tracking:activity:`
 */
export var TrackingEvents;
(function (TrackingEvents) {
    // Commerce events
    TrackingEvents["TrackingCartOpen"] = "tracking:commerce:view_cart";
    TrackingEvents["TrackingCartQuantityAdd"] = "tracking:commerce:add_to_cart";
    TrackingEvents["TrackingCartQuantityRemove"] = "tracking:commerce:remove_from_cart";
    TrackingEvents["TrackingCheckoutAddPaymentInfo"] = "tracking:commerce:add_payment_info";
    TrackingEvents["TrackingCheckoutAddShippingInfo"] = "tracking:commerce:add_shipping_info";
    TrackingEvents["TrackingCheckoutBeginCheckout"] = "tracking:commerce:begin_checkout";
    TrackingEvents["TrackingCheckoutProgress"] = "tracking:commerce:checkout_progress";
    TrackingEvents["TrackingMyOrdersReorder"] = "tracking:commerce:re_order";
    TrackingEvents["TrackingOrderSummaryPurchase"] = "tracking:commerce:purchase";
    TrackingEvents["TrackingSelectItem"] = "tracking:commerce:select_item";
    TrackingEvents["TrackingViewItem"] = "tracking:commerce:view_item";
    TrackingEvents["TrackingViewItemList"] = "tracking:commerce:view_item_list";
    // Subscription events
    TrackingEvents["TrackingMySubscriptionPause"] = "tracking:commerce:pause_subscription";
    TrackingEvents["TrackingMySubscriptionResume"] = "tracking:commerce:resume_subscription";
    TrackingEvents["TrackingMySubscriptionStop"] = "tracking:commerce:stop_subscription";
    TrackingEvents["TrackingMySubscriptionAddItem"] = "tracking:commerce:add_to_subscription";
    TrackingEvents["TrackingMySubscriptionRemoveItem"] = "tracking:commerce:remove_item";
    TrackingEvents["TrackingMySubscriptionDecreaseCarton"] = "tracking:commerce:decrease_carton";
    TrackingEvents["TrackingMySubscriptionIncreaseCarton"] = "tracking:commerce:increase_carton";
    // Non-commerce events
    TrackingEvents["TrackingCheckoutPageView"] = "tracking:activity:checkout:pageView";
    TrackingEvents["TrackingCodeSubmitSuccess"] = "tracking:activity:code:submit:success";
    TrackingEvents["TrackingCreateAccountClick"] = "tracking:activity:createaccount:click";
    TrackingEvents["TrackingCtaClick"] = "tracking:activity:cta:click";
    TrackingEvents["TrackingEvent"] = "tracking:activity:event";
    TrackingEvents["TrackingFaqLink"] = "tracking:activity:faq:link";
    TrackingEvents["TrackingFaqSearchClick"] = "tracking:activity:faq:searchClick";
    TrackingEvents["TrackingFaqSearchResultClick"] = "tracking:activity:faq:searchResultClick";
    TrackingEvents["TrackingFlavorFinderProgress"] = "tracking:activity:flavorfinder:progress";
    TrackingEvents["TrackingFlavorFinderResult"] = "tracking:activity:flavorfinder:result";
    TrackingEvents["TrackingFreeTrialStart"] = "tracking:activity:freetrial:start";
    TrackingEvents["TrackingFollow"] = "tracking:activity:follow";
    TrackingEvents["TrackingHardAgeVerificationStart"] = "tracking:activity:hardageverification:start";
    TrackingEvents["TrackingHardAgeVerificationSuccess"] = "tracking:activity:hardageverification:success";
    TrackingEvents["TrackingListClick"] = "tracking:activity:viewport:ListClick";
    TrackingEvents["TrackingLoginKakao"] = "tracking:activity:login:kakao";
    TrackingEvents["TrackingLoginFail"] = "tracking:activity:login:fail";
    TrackingEvents["TrackingLoginSuccess"] = "tracking:activity:login:success";
    TrackingEvents["TrackingLogoutSuccess"] = "tracking:activity:logout:success";
    TrackingEvents["TrackingPointsHistoryClick"] = "tracking:activity:pointsHistory:click";
    TrackingEvents["TrackingRedeemCheckout"] = "tracking:activity:redeem:checkout";
    TrackingEvents["TrackingRedeemClick"] = "tracking:activity:redeem:click";
    TrackingEvents["TrackingReferralCodeCopyButtonClick"] = "tracking:activity:referralcodecopybutton:click";
    TrackingEvents["TrackingShopFilterInteraction"] = "tracking:activity:shop:filterinteraction";
    TrackingEvents["TrackingSignUpProgress"] = "tracking:activity:registration:singupProgress";
    TrackingEvents["TrackingSignUpRegular"] = "tracking:activity:registration:signupRegular";
    TrackingEvents["TrackingSocialIconClick"] = "tracking:activity:socialicon:click";
    TrackingEvents["TrackingUnsubscribe"] = "tracking:activity:unsubscribe:success";
    TrackingEvents["TrackingUpdateGtmPageName"] = "tracking:activity:updateGtmPageName";
    TrackingEvents["TrackingUserAccountDeviceDeregister"] = "tracking:activity:userAccount:deviceDeregister";
    TrackingEvents["TrackingUserAccountDeviceRegister"] = "tracking:activity:userAccount:deviceRegister";
    TrackingEvents["TrackingUserLoginDeviceRegister"] = "tracking:activity:userLogin:deviceRegister";
    TrackingEvents["VideoClick"] = "tracking:activity:video:click";
    TrackingEvents["VideoStop"] = "tracking:activity:video:stop";
    TrackingEvents["TrackingContactUsClick"] = "tracking:activity:contactUs:click";
    TrackingEvents["TrackingContactUsPhoneClick"] = "tracking:activity:contactUsPhone:click";
    TrackingEvents["TrackingBlogArticleClick"] = "tracking:activity:article:click";
    TrackingEvents["TrackingStoreLocatorClick"] = "tracking:activity:storeLocator:click";
    TrackingEvents["TrackingSubscribeBlockClick"] = "tracking:activity:subscribeBlock:click";
    TrackingEvents["TrackingMenuNavigationClick"] = "tracking:activity:menuNavigation:click";
    TrackingEvents["TrackingMenuNavigationListClick"] = "tracking:activity:menuNavigationList:click";
    TrackingEvents["TrackingCarouselClick"] = "tracking:activity:carousel:click";
    TrackingEvents["TrackingAgeVerificationClick"] = "tracking:activity:age:verification:click";
    TrackingEvents["TrackingSurveyStart"] = "tracking:activity:survey:start";
    TrackingEvents["TrackingSurveyProgress"] = "tracking:activity:survey:progress";
    TrackingEvents["TrackingSurveyCompletion"] = "tracking:activity:survey:completion";
})(TrackingEvents || (TrackingEvents = {}));
//# sourceMappingURL=types.js.map